import React, { useEffect, useState } from "react";
// Firestore imports removed
import { ApiService } from "../../services/api_service";
import useAuth from "../../hooks/use_auth";
import BookingCard from "./BookingCard";

const MyBookings = () => {
  const user = useAuth();
  const [bookings, setBookings] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBookingsAndEvents = async () => {
      if (!user) {
        setLoading(false);
        setBookings([]);
        setEvents([]);
        return;
      }
      setLoading(true);
      setError(null);
      try {
        // Fetch all bookings and filter by user ID
        const bookingsResponse = await ApiService.getAllBookings();
        let allBookings = bookingsResponse.data || bookingsResponse;

        // Handle if object
        if (allBookings && !Array.isArray(allBookings) && typeof allBookings === 'object') {
          allBookings = Object.values(allBookings);
        }
        if (!Array.isArray(allBookings)) allBookings = [];

        const userBookings = allBookings.filter(b => b.userId === user.uid);
        console.log("Bookings:", userBookings);

        // Fetch events
        const eventsResponse = await ApiService.getAllEvents();
        let allEvents = eventsResponse.data || eventsResponse;

        if (allEvents && !Array.isArray(allEvents) && typeof allEvents === 'object') {
          allEvents = Object.values(allEvents);
        }
        if (!Array.isArray(allEvents)) allEvents = [];

        const eventsData = allEvents.filter(event =>
          event.showInApp === true || event.showInApp === null || event.showInApp === undefined
        );

        setBookings(userBookings);
        setEvents(eventsData);
      } catch (err) {
        console.error(err);
        setError("Failed to fetch bookings and events");
        setBookings([]);
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };
    fetchBookingsAndEvents();
  }, [user]);

  return (
    <div className="min-h-screen bg-[#111111] flex flex-col px-4 sm:px-6 md:px-8 lg:px-[120px] pt-[100px] pb-20">
      <div className="w-full max-w-[1000px] mx-auto">
        <h1 className="text-3xl font-bold mb-8 text-white">My Bookings</h1>

        {loading ? (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#17BD3B] mb-4"></div>
            <div className="text-gray-400">Loading your bookings...</div>
          </div>
        ) : error ? (
          <div className="text-center text-red-400 py-16 bg-[#202020] rounded-xl border border-red-900/30">
            <div className="text-4xl mb-4">⚠️</div>
            <div>{error}</div>
            <button
              onClick={() => window.location.reload()}
              className="mt-4 px-6 py-2 bg-red-600/20 hover:bg-red-600/30 text-red-400 border border-red-600/50 rounded-lg transition"
            >
              Try Again
            </button>
          </div>
        ) : bookings.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 bg-[#202020] rounded-2xl border border-[#333]">
            <div className="text-6xl mb-6 opacity-50">🎟️</div>
            <div className="text-2xl font-bold text-white mb-2">No Bookings Yet</div>
            <p className="text-gray-400 mb-8 text-center max-w-md">
              You haven't booked any events yet. Explore our events and book your first experience!
            </p>
            <button
              onClick={() => window.location.href = '/'}
              className="px-8 py-3 bg-[#17BD3B] hover:bg-[#15a834] text-white rounded-lg font-semibold transition shadow-lg shadow-[#17BD3B]/20"
            >
              Browse Events
            </button>
          </div>
        ) : (
          <div className="space-y-6">
            {bookings.map((booking) => {
              const eventData = events.find(event => event.id === booking.eventId);
              return (
                <BookingCard
                  key={booking.id}
                  booking={booking}
                  eventData={eventData}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyBookings;
